import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { LinearProgress, CircularProgress, FontIcon } from 'material-ui';

const styles = {
  wrapper: {
    textAlign: 'center',
  },

  loaderText: {
    color: '#9E9E9E',
    fontSize: '1.1em',
    display: 'block',
    padding: '.5em 0',
  },
};

export const PageWrapper = ({ offset, children }) => {
  const height = window.innerHeight - offset;
  const style = {
    ...styles.wrapper,
    height,
  };

  return (
    <div style={style}>
      <div
        style={{ height: '100%' }}
        className="uk-flex uk-flex-center uk-flex-middle"
      >
        {children}
      </div>
    </div>
  );
};

PageWrapper.propTypes = {
  offset: PropTypes.number,
  children: PropTypes.node,
};

PageWrapper.defaultProps = {
  offset: 0,
};

export const PageLoader = ({ title, circular, withHeader, ...otherProps }) => (
  <PageWrapper {...{ ...otherProps, ...withHeader && { offset: 48 } }} >
    { circular ? (
      <CircularProgress />
    ) : (
      <div style={{ width: '50%' }}>
        <span className="uk-text-center" style={styles.loaderText}>{title}</span>
        <LinearProgress mode="indeterminate" />
      </div>
    ) }
  </PageWrapper>
);

PageLoader.propTypes = {
  title: PropTypes.string,
  circular: PropTypes.bool,
  withHeader: PropTypes.bool,
};

const defaultIconStyle = {
  color: '#9E9E9E',
  fontSize: 45,
};

export const EmptyPage = ({ iconStyle, icon, children, ...rest }) => (
  <PageWrapper {...rest}>
    <div>
      <div>
        <FontIcon
          className="material-icons"
          style={{ ...defaultIconStyle, ...iconStyle }}
        >
          {icon}
        </FontIcon>
      </div>
      <span className="empty-title">{children}</span>
    </div>
  </PageWrapper>
);

EmptyPage.propTypes = {
  iconStyle: PropTypes.shape({}),
  icon: PropTypes.string,
  children: PropTypes.node,
};

export const RandomEmptyPage = ({ children }) => {
  const variants = children;
  return variants[_.random(0, variants.length - 1)];
};

RandomEmptyPage.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
};



// WEBPACK FOOTER //
// ./src/components/PageWrapper.js